/**
 * AUTO-GENERATED from schema.json — DO NOT EDIT
 * Source: Image Text Columns (image_text_columns)
 * Run `yarn workspace @library/cms-blocks cms:types` to regenerate
 */

import { z } from 'zod'
import { CmsAssetSchema, RichTextContentSchema } from '../../types/contentstack-zod'
import { RawCmsCtaSchema } from '../../cta'

export const ImageTextColumnsFieldsSchema = z
  .object({
    heading: z.string().max(80),
    heading_level: z.enum(['h2', 'h3']),
    image_position: z.enum(['left', 'right']),
    image: CmsAssetSchema,
    image_mobile: CmsAssetSchema.nullish(),
    image_alt: z.string().max(200),
    body: RichTextContentSchema.nullish(),
    sub_sections_heading: z.string().max(100).nullish(),
    sub_sections_body: z.string().max(400).nullish(),
    sub_sections: z
      .array(
        z
          .object({
            sub_heading: z.string().max(100),
            sub_body: z.string().max(400),
            body: RichTextContentSchema.nullish(),
            show_tick_icon: z.boolean().nullish(),
          })
          .passthrough(),
      )
      .nullish(),
    closing_body: z.string().max(400).nullish(),
    cta: RawCmsCtaSchema.nullish(),
  })
  .passthrough()
